import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../confi";
import Spinner from "../../Loader/Spinner";
function ReceptOlia(props) {
  let freedate = props.free_date;

  const [member_id, setmember_id] = useState("");
  const [miti_id, setmiti_id] = useState("");
  const [display_name, setdisplay_name] = useState("");
  const [day, setDay] = useState("");
  const [name, setname] = useState("");
  const [year, setYear] = useState("");
  const [mobile, setmobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState("");

  /////------------fetch informaton by member reciet id -----////

  const fetch_miti = async (e) => {
    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_fe_mi",
      payload: { member_reciet_no: member_id },
    });

    try {
      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log(response);

      if (response.status === 200 && response.data.status === "0") {
        if (response.data.data.length > 0) {
          setname(response.data.data[0].name_person);
          setmiti_id(response.data.data[0].miti_row);
          setmobile(response.data.data[0].mobile_no);
          setYear(response.data.data[0].membership_year);
        } else {
        }
      } else {
      }
    } catch (error) {}
  };

  ////////////- book date -------------- /////////////

  const handleSubmit_date = async () => {
    if (freedate === "" || miti_id === "" || day === "") {
      return;
    }

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_bo_olia",
      payload: {
        miti_ref: miti_id,
        dis_date: freedate,
        dis_name: display_name,
        days: day,
      },
    });

    try {
      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log(response);

      if (response.status === 200 && response.data.status === "0") {
        props.success_msg("1", "date slot booked");
        setmsg("date slot booked");
      } else {
      }
      setLoading(false);
    } catch (error) {}
  };

  /// ----------------------- delete function ----////

  const handledelete = async () => {
    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_bo_oli_de",
      payload: { miti_row: props.res_data.miti_row },
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(response);

      if (response.status === 200 && response.data.status === "0") {
        // setmsg("success removed");
        props.success_msg("1", "Successfully Remove");
      } else {
      }
      setLoading(false);
    } catch (error) {}
  };

  return (
    <>
      {loading ? (
        <span className="book_msg">
          <Spinner />
        </span>
      ) : (
        <div className="Receipt-card">
          <div className="num">1</div>
          <div className="main-Receipt">
            <div>
              <input
                type="text"
                value={props.res_data.membership_rec_no || member_id}
                disabled={props.inputDisabled}
                onChange={(e) => setmember_id(e.target.value)}
              />
              <button
                  className="Receipt-card-submit"
                disabled={props.buttonDisabled}
                onClick={fetch_miti}
              >
                Fetch
              </button>
            </div>
            <div>
              <p>
                Member Name&nbsp;:&nbsp;{props.res_data.name_person || name}
              </p>
              <p>
                <span style={{ marginRight: "2em" }}>
                  Membership Year&nbsp;:&nbsp;
                  {props.res_data.membership_year || year}
                </span>
                <span>
                  Mobile No&nbsp;:&nbsp; {props.res_data.mobile_no || mobile}
                </span>
              </p>
            </div>
            <div>
              <label style={{ marginRight: "1em" }}>Display Name</label>
              <input
                style={{ background: "#fdfa8e" }}
                type="text"
                name="dis_name"
                value={props.res_data.dis_name || display_name}
                onChange={(e) => setdisplay_name(e.target.value)}
                disabled={props.inputDisabled}
              />
              <br></br>
              <label className="small-screen-day-label"> Days </label>
              <input
                className="Recept-input-day"
                placeholder="Days"
                value={day}
                name="dis_day"
                onChange={(e) => setDay(e.target.value)}
                disabled={props.inputDisabled}
              />

              <div className="R-b">
                <button
                  className="Receipt-card-submit"
                  onClick={handleSubmit_date}
                  disabled={props.buttonDisabled}
                >
                  Submit
                </button>

                <button
                  className="Receipt-card-submit"

                  onClick={handledelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ReceptOlia;
